import Const from 'constants';
import $ from 'jquery';
import BaseLineup from 'services/sports/default/base-lineup';
import {round} from 'helpers/number-helper';

export default class LineupSinglegame extends BaseLineup {
    getValidationRules({defaultValue = {}, ...rest}) {
        return {
            exposureMinPropNames: [
                'exposureMin',
                'captain_exposureMin',
            ],
        };
    }

    sumPlayersProperty({incomingValues: {players, prop}}) {
        let result = 0;
        players.map((player) => {
            result += Number(player.getPropValueOfLineupRole(prop));
        });

        return result;
    }

    sumPlayersRoundedProperty({incomingValues: {players, prop, decimalPlacesCount = 0}}) {
        return players.reduce((propSum, player) => {
            const propValue = Number(player.getCapPropValue(prop));

            return propSum + round(propValue, decimalPlacesCount);
        }, 0);
    }

    setPlayersByColumns({incomingValues: {team}}) {
        let captain = null;
        let flex = [];
        team.map((player) => {
            if (player.getIsCaptain()) {
                captain = {...player, positionInLineup: 'MVP - 1.5X Points'};
            } else {
                flex.push({...player, positionInLineup: 'UTIL'});
            }
        });
        return $.merge([captain], flex);
    }

    recalculateLineupsUsedPlayers({incomingValues: {lineups}}) {
        const usedPlayers = {};

        Object.values(lineups).map((lineup) => {
            lineup.players.map((player) => {
                let id = player.playerId + '_';
                if (player.getIsCaptain()) {
                    id += Const.LP_CAPTAIN_PLAYER_POSITION;
                } else {
                    id += Const.LP_COMMON_PLAYER_POSITION;
                }

                usedPlayers[id] ??= {...player, usedLineupsCount: 0};
                usedPlayers[id].usedLineupsCount++;
            });
        });

        return Object.values(usedPlayers);
    }
}
